import { createReducer, on } from '@ngrx/store';
import { ReportActions } from './report.actions';
import { ReportState, initialReportState, reportState } from './report.state';

export const reportReducer = createReducer(
  reportState,
  on(ReportActions.reset, (): ReportState => initialReportState),
  on(
    ReportActions.update,
    (state, { report }): ReportState => ({ ...state, ...report })
  ),
  on(
    ReportActions.setReports,
    (state, { reports }): ReportState => ({ ...state, reports })
  ),
  on(
    ReportActions.setSelectedReportType,
    (state, { reportType }): ReportState => ({
      ...state,
      selectedReportType: reportType
    })
  ),
  on(
    ReportActions.fetchReports,
    (state): ReportState => ({
      ...state,
      fetchingReports: true,
      fetchingReportsCount: state.fetchingReportsCount + 1,
      fetchingReportsError: undefined
    })
  ),
  on(ReportActions.fetchReportsSuccess, (state, { reports }): ReportState => {
    const reportList: ReportState['reports'] = [];
    for (const report of reports) {
      let availability: ReportState['reports'][0]['availability'] =
        'NEED_TO_PURCHASE';
      if (report.reportHasReleased) {
        availability = 'REPORT_RELEASED';
      } else if (report.userHasActivated) {
        availability = 'UNLOCKED';
      } else if (
        report.unlockPurchaseStatus &&
        report.unlockPurchaseStatus.available &&
        report.unlockPurchaseStatus.productId &&
        report.unlockPurchaseStatus.unlockType
      ) {
        availability = 'NEED_TO_UNLOCK';
      }
      reportList.push({
        ...report,
        availability
      });
    }
    return {
      ...state,
      reports: reportList,
      fetchingReports: false,
      fetchingReportsError: undefined
    };
  }),
  on(
    ReportActions.fetchReportsFailed,
    (state, { error }): ReportState => ({
      ...state,
      reports: [],
      fetchingReports: false,
      fetchingReportsError: error
    })
  ),
  on(
    ReportActions.setReportHighlightedPanels,
    (state, { count, results }): ReportState => ({
      ...state,
      reportHighlightedPanels: {
        count,
        results
      }
    })
  ),
  on(
    ReportActions.setDNAGuidelineByReportType,
    (state, { reportType, data }): ReportState => {
      const newState = {
        ...state
      };

      const dataIndex = state.dnaGuideline.findIndex(
        (item) => item.reportType === reportType
      );
      if (dataIndex >= 0) {
        newState.dnaGuideline[dataIndex] = {
          reportType: reportType,
          data: data
        };
      } else {
        newState.dnaGuideline = [
          ...state.dnaGuideline,
          {
            reportType,
            data
          }
        ];
      }
      return newState;
    }
  ),
  on(ReportActions.fetchDNAReportFigure, (state) => ({
    ...state,
    loading: {
      ...state.loading,
      fetchDnaReportFigure: true
    }
  })),
  on(
    ReportActions.fetchDNAReportFigureSuccess,
    (state, { reportType, data }) => {
      const newState = {
        ...state,
        loading: {
          ...state.loading,
          fetchDnaReportFigure: false
        }
      };
      const dataIndex = state.dnaReportFigure.findIndex(
        (item) => item.reportType === reportType
      );
      if (dataIndex >= 0) {
        const dnaReportFigure = [...state.dnaReportFigure];
        dnaReportFigure[dataIndex] = {
          data,
          reportType
        };
        newState.dnaReportFigure = dnaReportFigure;
      } else {
        newState.dnaReportFigure = [
          ...newState.dnaReportFigure,
          {
            reportType,
            data
          }
        ];
      }
      return newState;
    }
  ),
  on(ReportActions.fetchDNAReportFigureFailed, (state, { reportType }) => {
    const newState = {
      ...state,
      loading: {
        ...state.loading,
        fetchDnaReportFigure: false
      }
    };
    const dataIndex = state.dnaReportFigure.findIndex(
      (item) => item.reportType === reportType
    );
    if (dataIndex) {
      const dnaReportFigure = [...state.dnaReportFigure];
      dnaReportFigure.splice(dataIndex, 1);
      newState.dnaReportFigure = dnaReportFigure;
    }
    return newState;
  }),
  on(ReportActions.setProductViewModal, (state, payload) => ({
    ...state,
    productViewModal: {
      ...state.productViewModal,
      isOpen: payload.isOpen,
      productId: payload.productId ?? state.productViewModal.productId
    }
  })),
  on(ReportActions.fetchLabTrackingFromReports, (state) => ({
    ...state,
    labTrackingFromReportsQuery: {
      ...state.labTrackingFromReportsQuery,
      loading: true,
      error: undefined
    }
  })),
  on(ReportActions.fetchLabTrackingFromReportsSuccess, (state, payload) => ({
    ...state,
    labTrackingFromReportsQuery: {
      ...state.labTrackingFromReportsQuery,
      queryCount: state.labTrackingFromReportsQuery.queryCount + 1,
      count: payload.count,
      items: payload.items,
      loading: false,
      error: undefined
    }
  })),
  on(ReportActions.fetchLabTrackingFromReportsFailed, (state, payload) => ({
    ...state,
    labTrackingFromReportsQuery: {
      ...state.labTrackingFromReportsQuery,
      queryCount: state.labTrackingFromReportsQuery.queryCount + 1,
      loading: false,
      error: {
        message: payload.error.message
      }
    }
  }))
);
